import { useState, useEffect } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import IntroPage from './pages/IntroPage'
import DashboardPage from './pages/DashboardPage'
import type { AppState } from './types'

function App() {
  const [appState, setAppState] = useState<AppState>('intro')
  const navigate = useNavigate()

  useEffect(() => {
    // Route based on app state
    if (appState === 'intro') {
      navigate('/', { replace: true })
    } else if (appState === 'dashboard') {
      navigate('/dashboard', { replace: true })
    }
  }, [appState, navigate])

  const handleEnterDashboard = () => {
    setAppState('dashboard')
  }

  return (
    <div className="min-h-screen bg-paper-bg">
      <Routes>
        <Route 
          path="/" 
          element={<IntroPage onEnter={handleEnterDashboard} />} 
        />
        <Route 
          path="/dashboard/*" 
          element={<DashboardPage />} 
        />
      </Routes>
    </div>
  )
}

export default App